import React from 'react';
import styles from './StoryblocksMediaCard.module.css';
import {StoryblocksMediaItem} from '../../../data/models/Storyblocks/StoryblocksMediaItem';
import Tooltip2 from '../../../uiToolkit/Tooltip2/Tooltip2';

export interface StoryblocksMediaItemProps {
  item: StoryblocksMediaItem;
  isSelected: boolean;
  onClick: (item: StoryblocksMediaItem) => void;
}

const StoryblocksMediaCard: React.FC<StoryblocksMediaItemProps> = ({
  item,
  isSelected,
  onClick,
}) => {
  return (
    <Tooltip2 text={item.title}>
      <div
        className={`${styles.card} ${isSelected ? styles.selected : ''}`}
        onClick={() => onClick(item)}>
        <div className={styles.thumbnailWrapper}>
          {!isSelected ? (
            <>
              <img
                src={item.thumbnail_url}
                alt={item.title}
                className={styles.thumbnail}
              />
              <span className={styles.duration}>
                {formatDuration(item.duration)}
              </span>
            </>
          ) : (
            <video
              src={item.preview_urls._360p}
              className={styles.thumbnail}
              autoPlay
              playsInline
              controls
            />
          )}
        </div>
      </div>
    </Tooltip2>
  );
};

function formatDuration(seconds: number): string {
  const mins = Math.floor(seconds / 60);
  const secs = Math.floor(seconds % 60);
  return `${mins}:${secs.toString().padStart(2, '0')}`;
}

export default StoryblocksMediaCard;
